import { isEmpty } from 'underscore';
import { DownloadInfoItem, IBestDataset } from '../types/analytics';
import { IDatasetBrief } from '../types/metadata';
import { IBestDataset as IBestDatasetRep } from '../types/search';
import { DownloadCheckboxKey } from './common';

export enum DATASET_CATEGORIES {
  WAVES = 'Waves',
  ATMOSPHERE = 'Atmosphere',
  OCEAN = 'Ocean',
}

export function filterBestDataset(
  datasetBriefs: IDatasetBrief[],
  datasetRep: IBestDatasetRep
) {
  if (isEmpty(datasetRep)) {
    return [];
  }
  const bestDataset = new Array<IBestDataset>();
  if (!isEmpty(datasetRep.SW) && datasetRep.SW.length > 0) {
    const brief = datasetBriefs.find((b) => b.id === datasetRep.SW[0]);
    bestDataset.push({
      label: DATASET_CATEGORIES.WAVES,
      value: brief?.acronym || DATASET_CATEGORIES.WAVES,
      id: datasetRep.SW[0],
    });
  }
  if (!isEmpty(datasetRep.Wind) && datasetRep.Wind.length > 0) {
    const brief = datasetBriefs.find((b) => b.id === datasetRep.Wind[0]);
    bestDataset.push({
      label: DATASET_CATEGORIES.ATMOSPHERE,
      value: brief?.acronym || DATASET_CATEGORIES.ATMOSPHERE,
      id: datasetRep.Wind[0],
    });
  }
  if (!isEmpty(datasetRep.HD) && datasetRep.HD.length > 0) {
    const brief = datasetBriefs.find((b) => b.id === datasetRep.HD[0]);
    bestDataset.push({
      label: DATASET_CATEGORIES.OCEAN,
      value: brief?.acronym || DATASET_CATEGORIES.OCEAN,
      id: datasetRep.HD[0],
    });
  }
  return bestDataset;
}

export function generateMeshOptions(downloadInfoItems: DownloadInfoItem[]) {
  const result = new Array<IBestDataset>();

  if (isEmpty(downloadInfoItems)) {
    return result;
  }

  downloadInfoItems.forEach((d) => {
    const dataset = (d.options as IBestDataset[]).find(
      (x) => x.id === d.datasetId
    );
    if (dataset !== undefined) {
      switch (d.radioKey) {
        case DownloadCheckboxKey.SW:
          result.push({ ...dataset, label: DATASET_CATEGORIES.WAVES });
          break;
        case DownloadCheckboxKey.HD:
          result.push({ ...dataset, label: DATASET_CATEGORIES.OCEAN });
          break;
        case DownloadCheckboxKey.Wind:
          result.push({ ...dataset, label: DATASET_CATEGORIES.ATMOSPHERE });
          break;
        default:
          break;
      }
    }
  });

  return result;
}
